import { CommentPlusIcon } from './CommentPlusIcon';

/**
 * author: Peter Noble
 * id 6C595408-3938-4111-9566-7149810D4A73
 * name comment-plus
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-plus.svg
 * tags
 */
export const CommentAddIcon = CommentPlusIcon;
export default CommentAddIcon